var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"events"},[_vm._v("\n  DONATION GOALS\n  "),_c('div',_vm._l((_vm.overlayData),function(goals){return _c('li',[_vm._v("\n      "+_vm._s(goals.name)+": $"+_vm._s(goals.amount)+"\n    ")])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef11c912","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events.vue
// module id = null
// module chunks = 